import axios from 'axios';
import store from '../../store/store'; // Import Redux Store
import { showAlert } from '../components/global_alert/alertBus';
import { setAccessTokenWithExpiration, clearTokens } from '../../store/tokensSlice'; // Dostosuj ścieżkę

const baseURL = ''; // Podstawowy URL API
// const baseURL = 'https://api-dev.mapenapp.com/'; // Podstawowy URL API

const ApiService = axios.create({  
  baseURL: baseURL, // Podstawowy URL API
  timeout: 5000, // Limit czasu na odpowiedź (5 sekund)
});

// Interceptor żądań (np. dodawanie tokenów autoryzacyjnych)
ApiService.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    console.error('Błąd w żądaniu:', error);
    return Promise.reject(error);
  }
);

ApiService.checkTokenExpiration = async () => {
  const state = store.getState();
  const { accessToken, refreshToken, accessTokenExpiration, refreshTokenExpiration } = state.tokens;

    // Aktualny czas w milisekundach
    const currentTime = Date.now();

    // Konwersja dat wygaśnięcia na milisekundy
  const accessTokenExpiresAtMs = new Date(accessTokenExpiration).getTime();
  const refreshTokenExpiresAtMs = new Date(refreshTokenExpiration).getTime();

  // NOWE: Dodaj bufor 60 sekund (odśwież token, jeśli wygaśnie w ciągu 60 sekund)
  const BUFFER_TIME = 60 * 1000; // 60 sekund

  // Sprawdzenie, czy accessToken wygasł LUB wygaśnie wkrótce
  if (accessTokenExpiresAtMs && (accessTokenExpiresAtMs - BUFFER_TIME) < currentTime) {
    console.warn('Access token wygasł lub wygaśnie wkrótce.');

    // Sprawdzenie, czy refreshToken jest ważny
    if (refreshTokenExpiresAtMs && refreshTokenExpiresAtMs > currentTime) {
      console.log('Odświeżanie tokenu...');
      try {
        const newTokens = await ApiService.refreshTokens(refreshToken);
        return true;
      } catch (error) {
        console.error('Błąd podczas odświeżania tokenu:', error);
        showAlert('Sesja wygasła. Zaloguj się ponownie.');
        store.dispatch(clearTokens());
        window.location.href = '/login';
        return false;
      }
    } else {
      console.warn('Refresh token również wygasł. Wylogowywanie użytkownika...');
      showAlert('Sesja wygasła. Zaloguj się ponownie.');
      store.dispatch(clearTokens());
      window.location.href = '/login';
      return false;
    }
  }

  console.log('Tokeny są ważne.');
  return true;
};

ApiService.refreshTokens = async (refreshToken) => {
  try {
    const response = await ApiService.get('/api/auth/access-token', {
      headers: {
        Authorization: `Bearer ${refreshToken}`, // Dodanie refreshToken do nagłówka
      },
    });

    const { token: accessToken, expiresAt: accessTokenExpiresAt } = response.data;

   store.dispatch(setAccessTokenWithExpiration({
     accessToken,        
     accessTokenExpiresAt,
   }));

    // DEBUGOWANIE
    console.log('✅ Dispatch wysłany');
    console.log('📦 Nowy token:', accessToken);
    console.log('⏰ Wygaśnięcie:', accessTokenExpiresAt);
    
    // Sprawdź stan Redux zaraz po dispatch
    setTimeout(() => {
      const state = store.getState();
      console.log('🔍 Stan Redux po dispatch:', state.tokens);
    }, 100);

    return { accessToken, accessTokenExpiresAt };
  } catch (error) {
    console.error('❌ Błąd podczas odświeżania tokenu:', error);
    throw error;
  }
};

// Interceptor żądań (dodawanie tokenów autoryzacyjnych)
ApiService.getHeadersJsonUTF8OrDifferent = (contentType = 'application/json; charset=UTF-8') => {
  const token = store.getState().tokens.accessToken;

  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': contentType,
  };
};
ApiService.getHeaderOnlyToken = () => {
  const token = store.getState().tokens.accessToken;

  return {
    Authorization: `Bearer ${token}`,
  };
};


// Interceptor odpowiedzi (obsługa błędów)
ApiService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, data } = error.response;
      switch (status) {
        case 400:
          console.error('Błąd 400: Nieprawidłowe żądanie', data);

          if (error.config?.url === '/api/auth/login') {
            showAlert('Nieprawidłowe hasło.');
          } else {
            showAlert('Nieprawidłowe dane.');
          }
          break;
        case 401:
          console.error('Błąd 401: Nieautoryzowany', data);
          showAlert('Sesja wygasła. Zaloguj się ponownie.');
          // ZMIANA: Używaj action z Redux Toolkit
          store.dispatch(clearTokens());
          window.location.href = '/login';
          break;
        case 403:
          console.error('Błąd 403: Brak dostępu', data);
          showAlert('Nie masz uprawnień do wykonania tej operacji.');
          break;
        case 404:
          console.error('Błąd 404: Nie znaleziono zasobu', data);
          showAlert('Nie znaleziono zasobu.');
          break;
        case 500:
          console.error('Błąd 500: Błąd serwera', data);
          showAlert('Wystąpił błąd serwera. Spróbuj ponownie później.');
          break;
        default:
          console.error(`Błąd ${status}:`, data);
          showAlert('Wystąpił nieoczekiwany błąd. Spróbuj ponownie.');
      }
    } else if (error.request) {
      console.error('Brak odpowiedzi z serwera:', error.request);
      showAlert('Nie można połączyć się z serwerem. Sprawdź swoje połączenie internetowe.');
    } else {
      console.error('Błąd:', error.message);
      showAlert('Wystąpił błąd. Spróbuj ponownie.');
    }
    return Promise.reject(error);
  }
);

///-------------------------------------------------------------------------
// Funkcja logowania
ApiService.login = async (login, pass) => {
  try {
    const response = await ApiService.post('/api/auth/login', {
      login,
      pass,
    });
    return response.data; // Zwróć dane odpowiedzi (np. tokeny)
  } catch (error) {
    throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
  }
};
///-------------------------------------------------------------------------
// events

ApiService.getEvents = async (sortBy, sortDirection, pageNumber, searchQuery) => {
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    try {
        const payload = {
            ...(sortBy !== null && sortDirection !== null && { sortBy }),
            ...(sortBy !== null && sortDirection !== null && { sortDirection }),
            ...(searchQuery !== null && { searchQuery }),
            pageNumber
        }
        const response = await ApiService.get('/api/events/by_owner/paginated-sorted-and-with-search', {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
            params: payload,
        });
        return response.data; // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getEvents2 = async () => {
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/events/by_owner', {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getEventsTopCharts = async (path) => {
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/events/top/' + path, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getEvent = async (eventId) => {
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/events/' + eventId, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getAllImagesForEvent = async (eventId) => {
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/events-images/by-event-id/' + eventId, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getEventsCategories = async () => {
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.get('/api/events-categories', {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.updateEvent = async (id, data) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.put('/api/events/'+ id, data, {
            headers: ApiService.getHeadersJsonUTF8OrDifferent(),
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

ApiService.deleteEventImage = async (id) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.delete('/api/events-images/'+ id, {
            headers: ApiService.getHeadersJsonUTF8OrDifferent(),
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

ApiService.addNewEvent = async (data) => {
    await ApiService.checkTokenExpiration();

    try {
        const response = await ApiService.post('/api/events', data, {
            headers: ApiService.getHeadersJsonUTF8OrDifferent(),
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

ApiService.uploadEventImage = async (eventId, file) => {
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne
    await ApiService.checkTokenExpiration();

    const formData = new FormData();
    formData.append('file', file); // Dodanie pliku do formData

    try {
        const response = await ApiService.post('/api/events-images/image-upload/' + eventId, formData, {
            headers: ApiService.getHeadersJsonUTF8OrDifferent('multipart/form-data'),
        });
        return response.data; // Zwróć ciąg znaków zwrócony przez endpoint
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

// ---------------------------------------------------------------------------------------------------
// statistics
// ---------------------------------------------------------------------------------------------------

ApiService.getPieStatisticsViews = async (eventId) => {
    console.log("EventId: " + eventId);
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    const url = eventId === 0 ? '/api/event-statistics/viewing' : '/api/event-statistics/viewing/' + eventId;

    try {
        const response = await ApiService.get(url, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getPieStatisticsBunches = async (eventId) => {
    console.log("EventId: " + eventId);
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    const url = eventId === 0 ? '/api/bunch-statistics' : '/api/bunch-statistics/' + eventId;

    try {
        const response = await ApiService.get(url, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getPieStatisticsUsers = async (eventId) => {
    console.log("EventId: " + eventId);
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    const url = eventId === 0 ? '/api/bunch-statistics/new-or-old' : '/api/bunch-statistics/new-or-old/' + eventId;

    try {
        const response = await ApiService.get(url, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getComparisonStatistics = async (eventId) => {
    console.log("EventId: " + eventId);
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    const url = '/api/bunch-statistics/event-share-comparison-by-category/' + eventId;

    try {
        const response = await ApiService.get(url, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getChartOneStatistics = async (from, to, eventId) => {
    console.log("EventId: " + eventId);
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    const encodedFrom = encodeURIComponent(from);
    const encodedTo = encodeURIComponent(to);

    const url = eventId === 0 ? '/api/bunch-statistics/activity-chart/' + encodedFrom + '/' + encodedTo : '/api/bunch-statistics/activity-chart/' + encodedFrom + '/' + encodedTo + '/' + eventId;

    try {
        const response = await ApiService.get(url, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

ApiService.getChartOneStatisticsBySex = async (from, to, eventId, sex) => {
    console.log("EventId: " + eventId);
    // Sprawdzenie ważności tokenów i odświeżenie, jeśli to konieczne lub usuniecie danych o tokenach i przekierowanie na stronę logowania
    await ApiService.checkTokenExpiration();

    const encodedFrom = encodeURIComponent(from);
    const encodedTo = encodeURIComponent(to);

    const url = eventId === 0 ? '/api/bunch-statistics/activity-chart-by-sex/' + encodedFrom + '/' + encodedTo + '/' + sex : '/api/bunch-statistics/activity-chart-by-sex/' + encodedFrom + '/' + encodedTo + '/' + eventId + '/' + sex;

    try {
        const response = await ApiService.get(url, {
            headers: ApiService.getHeaderOnlyToken(), // Dodanie tokenu do nagłówka
        });
        return response // Zwróć dane użytkowników
    } catch (error) {
        throw error; // Obsługa błędów jest już zaimplementowana w interceptorze
    }
};

export default ApiService;

